export default "__VITE_ASSET__Cdiv9vRC__"